import { render, staticRenderFns } from "./LandingHero.vue?vue&type=template&id=2a42622f&scoped=true"
import script from "./LandingHero.vue?vue&type=script&lang=js"
export * from "./LandingHero.vue?vue&type=script&lang=js"
import style0 from "./LandingHero.vue?vue&type=style&index=0&id=2a42622f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42622f",
  null
  
)

export default component.exports